import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import SenderSelect, { useMe } from './SenderSelect';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 1:1 email from a contact card: defaults to you (your Outlook), or send as a colleague.
export default function ContactEmailButton({ contact, onSent }) {
  const me = useMe();
  const [open, setOpen] = useState(false);
  const [sender, setSender] = useState(null);
  const [f, setF] = useState({ subject: '', body: '' });
  const [busy, setBusy] = useState(false);
  const from = sender || me;
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/contacts/${contact.id}/send-email`, { ...f, sender_member_id: from });
      toast.success(`Email sent${data.from ? ` from ${data.from}` : ''}`);
      setOpen(false); setF({ subject: '', body: '' }); onSent && onSent();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not send'); }
    finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="flex items-center gap-2 text-sm text-[#ffffff] bg-[#00A79D] hover:bg-[#00857D] rounded-md px-3 py-2" data-testid="contact-send-email-btn">
        <Send className="w-4 h-4" /> Send email
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-2xl" data-testid="contact-email-dialog">
          <DialogHeader>
            <DialogTitle className="text-[#ffffff]">Email {contact.full_name || contact.email}</DialogTitle>
            <DialogDescription className="text-slate-400">To {contact.email}. Sending as yourself uses your connected Outlook; choosing a colleague sends through the CRM as them.</DialogDescription>
          </DialogHeader>
          <label className="text-xs font-semibold text-slate-400 uppercase tracking-wide">Send from
            <SenderSelect value={from} onChange={(v) => setSender(v)} dark allowBrand={false} testid="contact-email-from" />
          </label>
          <input value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} placeholder="Subject"
            className="bg-slate-950 border border-slate-700 rounded-md px-3 py-2 text-sm text-[#ffffff]" data-testid="contact-email-subject" />
          <textarea value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} rows={8} placeholder="Write your message - the sender's signature is added automatically"
            className="bg-slate-950 border border-slate-700 rounded-md px-3 py-2 text-sm text-[#ffffff]" data-testid="contact-email-body" />
          <div className="flex justify-end">
            <button onClick={send} disabled={busy || !f.subject.trim() || !f.body.trim() || !from} data-testid="contact-email-send"
              className="inline-flex items-center gap-1.5 bg-[#00A79D] hover:bg-[#00857D] text-[#ffffff] text-sm font-semibold rounded-md px-4 py-2 disabled:opacity-50">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
